import {IServiceRequestComment} from '../api-response/service-request/service-request-comment';
import {IServiceRequestUser} from '../api-response/service-request/service-request-user';

export class ServiceRequestComment implements IServiceRequestComment {
    serviceRequest: number;
    comment: string = '';
    isNotify: boolean = false;
    isPrivate: boolean;
    isPublic: boolean = false;
    user: IServiceRequestUser;

    constructor(user: IServiceRequestUser, isPrivate = true) {
        this.user = user;
        this.isPrivate = isPrivate;
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/ServiceRequestComment.ts